import { bind } from 'decko'
import { LiveNodeList } from 'live-node-list'
import { getScrollProgress, registerSlideshow } from './slideshow-helpers'

export default class SlideshowProgress {
  /**
   * @type {LiveNodeList}
   */
  progressBars = new LiveNodeList('.slideshow-progress')

  constructor() {
    this.registerListeners()
  }

  registerListeners() {
    this.progressBars.on('update', (newItems, oldItems) => {
      newItems.forEach(this.registerSlideshow)
      oldItems.forEach(this.unregisterSlideshow)
    })

    this.progressBars.forEach(this.registerSlideshow)
  }

  @bind
  registerSlideshow(item) {
    const target = document.getElementById(item.getAttribute('aria-controls'))
    registerSlideshow(item, {
      onScroll: this.handleScroll.bind(this, item, target)
    })
  }

  @bind
  unregisterSlideshow(item) {
    unregisterSlideshow(item, {
      onScroll: this.handleScroll.bind(this, item, target)
    })
  }

  @bind
  handleScroll(item, target) {
    const progress = getScrollProgress(target)
    item.querySelector('.slideshow-progress__value').style.width = `${
      progress * 100
    }%`
  }
}
